import { render, staticRenderFns } from "./ProgramPhaseControls.vue?vue&type=template&id=70590e94"
import script from "./ProgramPhaseControls.vue?vue&type=script&lang=ts"
export * from "./ProgramPhaseControls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports